import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable , from} from 'rxjs';
import { AutenticacionService } from './autenticacion.service';
import { AppConfigService } from './app-config.service';
import { sprintf } from 'sprintf-js';
import { SSO } from '../models';
import { map } from 'rxjs/operators';


/**
 * Servicio para la gestión de la vinculacion con dispositivos.
 *
 * @author lreverendo
 * @author aarodriguezo
 *
 * @version 01.02.0400
 * @since 01.02.0100
 */
@Injectable({ providedIn: 'root' })
export class VinculacionDispositivosService {
  private ssoVinculacion = null;
  private httpheadersPost = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');

  constructor(private http: HttpClient, private autenticacionService: AutenticacionService) {}

  public setSSOVinculacion(bind_result: string, error: string, nombreSistema: string) {
    this.ssoVinculacion = new SSO(bind_result, error, nombreSistema);
  }

  public getSSOVinculacion(): SSO {
    return this.ssoVinculacion;
  }

  public recuperarUrlVinculacionDispositivo(nombreSistema: string): Observable<string> {
    console.log('URL completa:', window.location.href);
    let currentUrl = window.location.href;
    currentUrl = currentUrl.replace(/\/#\/.*/, '/sso');

    const dniPaciente = this.autenticacionService.getLoginPaciente();
    const codCentro = this.autenticacionService.getCentroPaciente();   
    const nasi = this.autenticacionService.getNasi();

    if (nombreSistema.toUpperCase() === 'DEXCOM') {
      return this.obtenerUrlVinculacionDexcom(nombreSistema, codCentro, nasi, currentUrl);
    }

    const url = sprintf(AppConfigService.urls.vinculacionDispositivos, dniPaciente, codCentro, nombreSistema, currentUrl);
    return this.http.get<{ url: string, code: number, message: string }>(url).pipe(
      map(response => response.url)
    );
  }

  private obtenerUrlVinculacionDexcom(nombreSistema: string, codCentro: string, nasi: string, currentUrl: string): Observable<string> {
    const token = AppConfigService.listaVinculacionDispositivos[nombreSistema].tokenAutorizacion;
    const tipoToken = AppConfigService.listaVinculacionDispositivos[nombreSistema].tipoToken;

    if (AppConfigService.listaVinculacionDispositivos[nombreSistema].urlVinculacion === null) {
      throw new Error('URL de vinculación no configurada');
    }
    const urlCompleta = `${AppConfigService.listaVinculacionDispositivos[nombreSistema].urlVinculacion}?nasi=${nasi}&hospital=${codCentro}&url=${currentUrl}`;

    return from(
      fetch(urlCompleta, {
        method: "GET",
        headers: {
          "Authorization": `${tipoToken} ${token}`,
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        console.log("Response:", data);
        return data.url;
      })
      .catch(error => {
        console.error("Error:", error);
        throw error;
      })
    );
  }

  public vincularDispositivoSuccess(body: any): Observable<Object> {
    const nombreSistema = this.ssoVinculacion.nombreSistema;
    this.ssoVinculacion = null;
    const dniPaciente = this.autenticacionService.getLoginPaciente();
    const codCentro = this.autenticacionService.getCentroPaciente();
    const url = sprintf(AppConfigService.urls.vinculacionDispositivosSuccess, dniPaciente, codCentro, AppConfigService.listaVinculacionDispositivos[nombreSistema].idSistema);
    return this.http.post<Boolean>(url, body, { headers: this.httpheadersPost });
  }

  public desvincularDispositivo(body: any): Observable<Object> {
    const nombreSistema = this.ssoVinculacion.nombreSistema;
    this.ssoVinculacion = null;
    const dniPaciente = this.autenticacionService.getLoginPaciente();
    const codCentro = this.autenticacionService.getCentroPaciente();
    const url = sprintf(AppConfigService.urls.desvinculacionDispositivo, dniPaciente, codCentro, AppConfigService.listaVinculacionDispositivos[nombreSistema].idSistema);
    return this.http.post<Boolean>(url, body, { headers: this.httpheadersPost });
  }
}

